<div
  class="ui-signature-pad"
  [class.ui-signature-pad--disabled]="disabled()"
  [class.ui-signature-pad--invalid]="invalid()"
  [class.ui-signature-pad--signed]="!isEmpty()"
>
  <div class="ui-signature-pad__header">
    <div class="ui-signature-pad__copy">
      <span class="ui-signature-pad__label" [id]="canvasId() + '-label'">
        {{ label() }}
      </span>
      @if (description()) {
        <p class="ui-signature-pad__description" [id]="descriptionId()">
          {{ description() }}
        </p>
      }
    </div>

    @if (required()) {
      <span
        class="ui-signature-pad__requirement"
        [class.ui-signature-pad__requirement--error]="invalid()"
        aria-hidden="true"
      >
        Obligatorio
      </span>
    }
  </div>

  <div #surface class="ui-signature-pad__surface">
    <canvas
      #signatureCanvas
      class="ui-signature-pad__canvas"
      [id]="canvasId()"
      role="img"
      [attr.aria-labelledby]="canvasId() + '-label'"
      [attr.aria-describedby]="ariaDescribedBy()"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-required]="required() ? 'true' : null"
      (pointerdown)="startDrawing($event)"
      (pointermove)="draw($event)"
      (pointerup)="stopDrawing($event)"
      (pointercancel)="stopDrawing($event)"
    ></canvas>

    @if (isEmpty()) {
      <span class="ui-signature-pad__placeholder" aria-hidden="true">
        {{ placeholder() }}
      </span>
    }
  </div>

  <div class="ui-signature-pad__footer">
    @if (message() && invalid() && showMessage()) {
      <p class="ui-signature-pad__message" [id]="messageId()" role="alert">
        {{ message() }}
      </p>
    } @else {
      <span class="ui-signature-pad__hint">
        {{ isEmpty() ? 'Aun no has firmado.' : 'Firma capturada.' }}
      </span>
    }

    <ui-button
      variant="secondary"
      size="sm"
      [disabled]="disabled() || isEmpty()"
      (pressed)="clearSignature()"
    >
      {{ clearLabel() }}
    </ui-button>
  </div>
</div>
